<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row" v-if="ChildRecordData.SubProgramName == 'Inland STRTP'">
                    <div class="col-md-4">
                        <h4>Intake Reports</h4>
                        <ReportDownloader report-label="STRTP Intake Paperwork Template"
                                          endpoint="Residential/Reports/ClientReports/GetSTRTPIntakePaperworkTemplate"
                                          :parameter-schema="ParamsClient"
                                          report-description="Generates PDF document with prefilled info for MH intake forms." />
                    </div>
                    <div class="col-md-4">
                        <h4>Monthly Reports</h4>
                        <ReportDownloader report-label="MH Monthly Summary Template"
                                          endpoint="Residential/Reports/ClientReports/MentalHealthMonthlySummaryReport"
                                          :parameter-schema="ParamsClientMonthYear"
                                          report-description="Generates a monthly Mental Health Services Summary to be downloaded and completed by the clinician." />
                    </div>
                    <div class="col-md-4">
                        <h4>Misc. Reports</h4>
                        <ReportDownloader report-label="Export MH Progress Notes"
                                          permission-requirement="CanExportMHProgressNotes"
                                          endpoint="Core/Files/GetGroupedDocuments/MHProgressNotes.pdf"
                                          :parameter-schema="ParamsChartChapterSectionStartEnd"
                                          report-description="Exports a list of MH progress notes in chronilogical order for the specified time period." />
                        <ReportDownloader report-label="Generate Monthly Standard MH Invoice Data"
                                          permission-requirement="Administrator"
                                          endpoint="MentalHealth/Billing/Reports/StandardInvoiceData"
                                          :parameter-schema="ParamsMonthYearClientSubProgramMembershipID"
                                          report-description="Generates Data To Be Used in Standard Invoice" />
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../../Core/UI/ReportDownloader.vue';
    export default {
        props: ["ChildRecordData"],
        data: function () {
            return {
                ParamsClientMonthYear: [
                    {
                        Label: "Client:",
                        Name: "ClientSubProgramMembershipID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Month:",
                        Name: "Month",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "January",
                                value: 1
                            },
                            {
                                text: "February",
                                value: 2
                            },
                            {
                                text: "March",
                                value: 3
                            },
                            {
                                text: "April",
                                value: 4
                            },
                            {
                                text: "May",
                                value: 5
                            },
                            {
                                text: "June",
                                value: 6
                            },
                            {
                                text: "July",
                                value: 7
                            },
                            {
                                text: "August",
                                value: 8
                            },
                            {
                                text: "September",
                                value: 9
                            },
                            {
                                text: "October",
                                value: 10
                            },
                            {
                                text: "November",
                                value: 11
                            },
                            {
                                text: "December",
                                value: 12
                            },
                        ]
                    },
                    {
                        Label: "Year:",
                        Name: "Year",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "2020",
                                value: 2020
                            },
                            {
                                text: "2021",
                                value: 2021
                            },
                            {
                                text: "2022",
                                value: 2022
                            },
                            {
                                text: "2023",
                                value: 2023
                            },
                            {
                                text: "2024",
                                value: 2024
                            },
                            {
                                text: "2025",
                                value: 2025
                            },
                            {
                                text: "2026",
                                value: 2026
                            }
                        ]
                    }
                ],
                ParamsMonthYearClientSubProgramMembershipID: [
                    {
                        Label: "Client:",
                        Name: "ClientSubProgramMembershipID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Month:",
                        Name: "Month",
                        Type: "Select",
                        Group: "MonthYear",
                        Value: "",
                        Options: [
                            {
                                text: "January",
                                value: 1
                            },
                            {
                                text: "February",
                                value: 2
                            },
                            {
                                text: "March",
                                value: 3
                            },
                            {
                                text: "April",
                                value: 4
                            },
                            {
                                text: "May",
                                value: 5
                            },
                            {
                                text: "June",
                                value: 6
                            },
                            {
                                text: "July",
                                value: 7
                            },
                            {
                                text: "August",
                                value: 8
                            },
                            {
                                text: "September",
                                value: 9
                            },
                            {
                                text: "October",
                                value: 10
                            },
                            {
                                text: "November",
                                value: 11
                            },
                            {
                                text: "December",
                                value: 12
                            },
                        ]
                    },
                    {
                        Label: "Year:",
                        Name: "Year",
                        Type: "Select",
                        Group: "MonthYear",
                        Value: "",
                        Options: [
                            {
                                text: "2024",
                                value: 2024
                            },
                            {
                                text: "2025",
                                value: 2025
                            },
                            {
                                text: "2026",
                                value: 2026
                            }
                        ]
                    },
                    {
                        Label: "OR",
                        Type: "Divider"
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Group: "DateRange",
                        Value: ""
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Group: "DateRange",
                        Value: ""
                    },
                    {
                        Label: "",
                        Type: "CheckBoxBool",
                        Options: [
                            {
                                name: "IncludeLockedDocuments",
                                text: "Include Locked Documents",
                                checked: false
                            }
                        ]
                    }
                ],
                ParamsStartEnd: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsClient: [
                    {
                        Label: "Client:",
                        Name: "ClientSubProgramMembershipID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    }
                ],
                ParamsChartChapterSectionStartEnd: [
                    {
                        Label: "Client:",
                        Name: "ChartID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Chapter Name:",
                        Name: "ChapterName",
                        Type: "HiddenConstant",
                        DisplayValue: "Mental Health",
                        Value: "MentalHealth"
                    },
                    {
                        Label: "Section Name:",
                        Name: "SectionName",
                        Type: "HiddenConstant",
                        DisplayValue: "MH Progress Notes",
                        Value: "MHProgressNotes"
                    },
                    {
                        Label: "Range Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Range End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }

                ]
            };
        },
        methods: {

        },
        computed: {
        },
        components: {
            ReportDownloader
        },
        mounted() {
            this.ParamsClientMonthYear[0].Value = this.ChildRecordData.Id
            this.ParamsClientMonthYear[0].DisplayValue = this.ChildRecordData.Person.FullName;
            this.ParamsClient[0].Value = this.ChildRecordData.Id
            this.ParamsClient[0].DisplayValue = this.ChildRecordData.Person.FullName;
            this.ParamsChartChapterSectionStartEnd[0].Value = this.ChildRecordData.Id;
            this.ParamsChartChapterSectionStartEnd[0].DisplayValue = this.ChildRecordData.Person.FullName;
            this.ParamsMonthYearClientSubProgramMembershipID[0].Value = this.ChildRecordData.Id;
            this.ParamsMonthYearClientSubProgramMembershipID[0].DisplayValue = this.ChildRecordData.Person.FullName;
        }
    }
</script>

<style scoped>
</style>